import RestService from "./RestService";


export default class TopTenService extends RestService {
    constructor() {
        super('/api/topten');
    }
}
